import type { MutateEndpoint } from '_api';

export const sendConfirmationLink: MutateEndpoint = {
    key: ['sendConfirmationLink'],
    method: 'POST',
    path: '/api/v3/profile/resend_activation_link',
    formatParams: () => ({ app: 'dashboard' }),
    simulator: { filepath: 'confirmationBottomBanner.sendConfirmationLink' }
};
